import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { cachedGet, errMsg } from "@/lib/api";
import { Loading, PageTitle, Pick, fmtDateTime } from "@/components/app/bits";

export default function AuditPage() {
  const { me } = useAuth();
  const [projects, setProjects] = useState([]);
  const [pid, setPid] = useState("");
  const [rows, setRows] = useState(null);
  useEffect(() => { cachedGet("/projects").then((r) => setProjects(r.data)).catch(() => {}); }, [me.active_org_id]);
  useEffect(() => {
    setRows(null);
    cachedGet("/audit", pid ? { project_id: pid, limit: 300 } : { limit: 300 }).then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [pid, me.active_org_id]);
  return (
    <div data-testid="audit-page">
      <PageTitle eyebrow="Audit trail" title="Every change, recorded">
        <Pick testid="audit-project-filter" value={pid} onChange={setPid} allLabel="All projects" options={projects.map((p) => [p.id, p.name])} className="w-64" />
      </PageTitle>
      {!rows ? <Loading /> : (
        <div className="panel overflow-x-auto">
          <table className="w-full text-sm min-w-[760px]" data-testid="audit-table">
            <thead><tr className="border-b border-[#1E2D4A] text-left font-mono text-[10px] uppercase tracking-wider text-slate-500">
              {["When (UTC)", "User", "Role", "Action", "Entity", "Details"].map((h) => <th key={h} className="px-3 py-3 font-medium">{h}</th>)}
            </tr></thead>
            <tbody>
              {rows.map((a) => (
                <tr key={a.id} className="border-b border-[#1E2D4A] last:border-0">
                  <td className="px-3 py-2.5 num text-xs text-slate-400 whitespace-nowrap">{fmtDateTime(a.at)}</td>
                  <td className="px-3 text-slate-200">{a.user_name}</td>
                  <td className="px-3 font-mono text-xs text-amber-400">{a.role}</td>
                  <td className="px-3 text-slate-300">{a.action}</td>
                  <td className="px-3 text-slate-400">{a.entity}</td>
                  <td className="px-3 text-slate-400 max-w-md truncate" title={a.details}>{a.details}</td>
                </tr>
              ))}
              {!rows.length && <tr><td colSpan={6} className="py-10 text-center text-slate-500">No changes recorded yet. Changes appear here as users work.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
